export default __webpack_public_path__ + "images/RLY.2aad75a.png";